import { getCurrentLocale } from "../i18n/helpers";

export const HttpCodes = {
  FOUND: 302,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  CONFLICT: 409,
  INTERNAL_ERROR: 500,
  PRE_CONDITION_FAILED: 412,
  OK: 200,
  OFFLINE_OR_CORS: 0,
};

export const modalType = {
  login: "login",
  recoverPassword: "recoverPassword",
  changePassword: "changePassword",
  accountConfirmation: "accountConfirmation",
  adminRegistrationProcess: "adminRegistrationProcess",
  inviteAdmin: "inviteAdmin",
  notice: "notice",
  loggedOut: "loggedOut",
};

export const profiles = {
  none: "none",
  participant: "Participant",
  executive: "Executive",
  itAdmin: "IT Admin",
  studyAdmin: "Study Admin",
  contentAdmin: "Content Admin",
  dietitian: "Dietitian",
  siteCoordinator: "Site Coordinator",
  pi: "Principal Investigator",
  siteMonitor: "Site Monitor",
  sponsor: "Sponsor",
  medicalMonitor: "Medical Monitor",
  dataManager: "Data Manager",
};

export const studiesIds = {
  gsdiii: "B6A48F33-5587-48BF-A980-4A8C3C8A87AB",
  lcfaod401: "3A9097F8-71EF-4C1E-8E74-E148EAABFAD1",
  lcfaod302: "a5461643-fa3f-46b8-b65a-22a147eebf9c",
};

export const studies = {
  none: "none",
  gsdiii: "GSDIII",
  lcfaod401: "LC-FAOD 401",
  lcfaod302: "LC-FAOD 302",
};

export const sidebarStatus = {
  hidden: "hidden",
  collapsed: "collapsed",
  expanded: "expanded",
};

//Need to add this line to avoid warnings with the regex escaping character
/* eslint-disable */
export const regex = new RegExp(
  "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\\[\\]!@#$%^&*^~+=`|\\(){}:;'<>,.?/\"_-]).{12,50}$"
);

export const nameRegex = new RegExp("\\d");

const emailRegexSTR =
  "[_a-zA-Z0-9-]+(\\.[_a-zA-Z0-9-]+)*(\\+[_a-zA-Z0-9-]+)?@[a-zA-Z0-9](([\\w\\-]*)[a-zA-Z0-9])*(\\.[a-zA-Z0-9](([\\w\\-]*)[a-zA-Z0-9])*)+";

export const emailRegex = new RegExp("^" + emailRegexSTR + "$");

export const phoneRegex = new RegExp(
  "^(9[976]|8[987530]|6[987]|5[90]|42|3[875]|2[98654321]|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1){1,14}$"
);

// participant id or email or caregiver id (XXX-XXX-A)
export const loginRegex = new RegExp(
  "^\\d{3}-\\d{3}\\-[a-zA-Z]{1}?$|^" + emailRegexSTR + "$"
);

// allow commas and dots
export const decimalRegex = new RegExp("^(?:\\d+)?(?:[\\,\\.](?:\\d+)?)?$");

export const tokenStatus = {
  valid: 1,
  invalid: 2,
};

export const tokenType = {
  registration: 1,
  password: 2,
  adminInvitation: 3,
};

export const FieldsValidation = {
  email: {
    size: 128,
    localPart: 64,
  },
  phone: {
    size: 20,
    minSize: 5,
  },
};

export const studyStatusOptions = {
  SCREENING: {
    id: 401,
    value: "Screening",
    showTargets: true,
  },
  TITRATION: {
    id: 402,
    value: "Titration",
    showTargets: true,
  },
  STABLE_TREATMENT: {
    id: 403,
    value: "Stable Treatment",
    showTargets: true,
  },
  RE_SCREENING: {
    id: 404,
    value: "Re-Screening",
    showTargets: true,
  },
  SCREEN_FAILURE: {
    id: 405,
    value: "Screen Failure",
    showTargets: false,
  },
  EARLY_TERMINATION: {
    id: 406,
    value: "Early Termination",
    showTargets: false,
  },
  END_STUDY: {
    id: 407,
    value: "End of Study",
    showTargets: false,
  },
};

export const getStudyStatusAvailableOptions = (studyStatus) => {
  switch (studyStatus.id) {
    case studyStatusOptions.SCREENING.id:
      return [
        studyStatusOptions.TITRATION,
        studyStatusOptions.SCREEN_FAILURE,
        studyStatusOptions.EARLY_TERMINATION,
      ];
    case studyStatusOptions.TITRATION.id:
      return [
        studyStatusOptions.STABLE_TREATMENT,
        studyStatusOptions.EARLY_TERMINATION,
      ];
    case studyStatusOptions.STABLE_TREATMENT.id:
      return [
        studyStatusOptions.EARLY_TERMINATION,
        studyStatusOptions.END_STUDY,
      ];
    case studyStatusOptions.SCREEN_FAILURE.id:
      return [studyStatusOptions.RE_SCREENING];
    case studyStatusOptions.RE_SCREENING.id:
      return [
        studyStatusOptions.TITRATION,
        studyStatusOptions.SCREEN_FAILURE,
        studyStatusOptions.EARLY_TERMINATION,
      ];
    case studyStatusOptions.EARLY_TERMINATION.id:
      return null;
    case studyStatusOptions.END_STUDY.id:
      return null;
    default:
      return null;
  }
};

export const unauthorizedStudyStatus = {
  lcfaod302: [
    studyStatusOptions.SCREEN_FAILURE,
    studyStatusOptions.EARLY_TERMINATION,
    studyStatusOptions.END_STUDY,
  ],
};

export const studyStatusesFAOD = {
  ACTIVE_DMP: {
    id: 101,
    value: "Active",
  },
  EARLY_TERMINATION: {
    id: 102,
    value: "Early Termination",
  },
  COMPLETE: {
    id: 103,
    value: "Complete",
  },
};

export const urlStudies = {
  gsdiii: "UX053-CL101",
  lcfaod401: "UX007-CL401",
  lcfaod302: "UX007-CL302",
};

export const modalHeaders = {
  login: "Login",
  register: "Set Up Account",
  loggedOut: "You’re now logged out",
  cookieConsent: "Cookie Settings",
};

export const FoodType = {
  COMMON: "common",
  BRANDED: "branded",
  CUSTOM: "custom",
};

export const dailyTargetIds = {
  CALORIES_ATTR_ID: 208,
  CARBS_ATTR_ID: 205,
  SUGAR_ATTR_ID: 269,
  LONG_CHAIN_FATS_ATTR_ID: -901, // custom attribute id, defined by Rarify BE
  MEDIUM_CHAIN_FATS_ATTR_ID: -900, // custom attribute id, defined by Rarify BE
  PROTEIN_ATTR_ID: 203,
};

export const PIE_CHART_SERIES_ATTRS = [
  dailyTargetIds.LONG_CHAIN_FATS_ATTR_ID,
  dailyTargetIds.MEDIUM_CHAIN_FATS_ATTR_ID,
  dailyTargetIds.CARBS_ATTR_ID,
  dailyTargetIds.PROTEIN_ATTR_ID,
];

export const MACRONUTRIENTS_401_ATTRS = {
  FATS_ATTR_ID: 204,
  LONG_CHAIN_FATS_ATTR_ID: -901, // custom attribute id, defined by Rarify BE
  MEDIUM_CHAIN_FATS_ATTR_ID: -900,
};

export const getMacronutrientColor = (attr_id, theme) => {
  switch (attr_id) {
    case dailyTargetIds.CARBS_ATTR_ID:
      return theme?.magentaPink;
    case dailyTargetIds.LONG_CHAIN_FATS_ATTR_ID:
      return theme?.green;
    case dailyTargetIds.MEDIUM_CHAIN_FATS_ATTR_ID:
      return theme?.darkGreen;
    case dailyTargetIds.PROTEIN_ATTR_ID:
      return theme?.blueMagenta;
    default:
      return theme?.c7Silver;
  }
};

export const getTargetsBgColor = (attr_id, theme, studyId = null) => {
  switch (attr_id) {
    case dailyTargetIds.CARBS_ATTR_ID:
      return studyId.toLocaleLowerCase() ===
        studiesIds.gsdiii.toLocaleLowerCase()
        ? theme?.pinkityDrinkity
        : theme?.vantaTeal;
    case dailyTargetIds.PROTEIN_ATTR_ID:
      return studyId.toLocaleLowerCase() ===
        studiesIds.gsdiii.toLocaleLowerCase()
        ? theme?.lightShadeBlueMagenta
        : theme?.pinkityDrinkity;
    default:
      return theme?.soulDance;
  }
};

export const Sites = {
  ALL: {
    id: null,
    value: "All",
  },
};

export const NotificationType = {
  EMAIL: 1,
  PHONE: 2,
};

export const getBaseDateFormat = () => {
  const locale = getCurrentLocale();

  if (locale === "ja") {
    return "YYYY年MMMDo";
  }

  return "DD/MMM/YYYY";
};

export const getBaseDateFormatWithTime = () => {
  return `${getBaseDateFormat()} hh:mm A`;
};

export const getExtendedDateFormat = () => {
  return `dddd ${getBaseDateFormat()}`;
};

export const getExtendedDateSmallFormat = () => {
  return `ddd ${getBaseDateFormat()}`;
};

export const getDateFormatWithoutYear = () => {
  const locale = getCurrentLocale();

  if (locale === "ja") {
    return "MMMDo";
  }

  return "MMM DD";
};

export const DateFormat = {
  EXTENDED_FORMAT: "dddd DD/MMM/YYYY",
  INVERTED_DATE: "YYYY-MM-DD",
  START_DATE: "YYYY-MM-DDT00:00:00",
  END_DATE: "YYYY-MM-DDT23:59:59",
  EXTENDED_DATETIME: "YYYY-MM-DDTHH:mm",
  HOUR: "hh:mm a",
  DATE_TIME: "YYYY-MM-DD HH:mm:ss",
};

export const TimeZone = {
  PST: "America/Los_Angeles",
};

export const TIME_FORMATS = [
  { id: "12h", value: "12 hour" },
  { id: "24h", value: "24 hour" },
];

export const REPORT_TYPES = {
  PDF_VERIFICATION_TOLERATED_DOSE_STUDY_DRUG: {
    id: "PDF_VERIFICATION_TOLERATED_DOSE_STUDY_DRUG",
    value: "PDF - Verification of Tolerated Dose of Study Drug",
    reportName: "VerificationOfToleratedDoseOfStudyDrug",
    minRangeDays: 6, // remove 6 days from current date to get a 7 days report
  },
  PDF_STUDY_DRUG_INTAKE: {
    id: "PDF_STUDY_DRUG_INTAKE",
    value: "PDF - Study Drug Intake",
    reportName: "StudyDrugIntake",
  },
  PDF_DAILY_AVERAGES: {
    id: "PDF_DAILY_AVERAGES",
    value: "PDF - Daily Averages",
    reportName: "DailyAverages",
  },
  CSV_DIET_RECORD_SUMMARY: {
    id: "CSV_DIET_RECORD_SUMMARY",
    value: "CSV - Diet Record Summary",
    name: "Diet Record Summary report",
  },
  CSV_24_HOUR: {
    id: "CSV_24_HOUR",
    value: "CSV - 24-hour",
    name: "24-Hour Diary Recall report",
  },
};

export const ChangeRequestStatus = {
  ALL: {
    id: null,
    value: "All",
  },
  OPEN: {
    id: 1,
    value: "Open",
  },
  APPROVED: {
    id: 2,
    value: "Approved",
  },
  DECLINED: {
    id: 3,
    value: "Declined",
  },
};

export const SurveyStatus = {
  ALL: {
    id: null,
    value: "All",
  },
  COMPLETED: {
    id: 1,
    value: "Completed",
  },
  TO_DO: {
    id: 2,
    value: "To Do",
  },
  EXPIRED: {
    id: 3,
    value: "Expired",
  },
};

export const kcalMultiplier = {
  carbs: 4,
  protein: 4,
  mcf: 8.6,
  lcf: 9,
};

export const timeConvert = {
  dayToMinutes: 1440,
  hourToMinutes: 60,
};

export const noDateDefinedOrEmpty = "0001-01-01T00:00:00";

export const RecoverPasswordType = {
  resetPassword: 0,
  forgotPassword: 1,
};

export const RTL_LOCALES = ["ar", "ar-SA"];

export const UNIT = { PERCENTAGE: "%", DEFAULT: "g" };

export const AUDIT_TRAIL_PARAMS_NAMES = {
  before: "before",
  after: "after",
  actor: "actor",
  actorType: "actorType",
  subjectAccount: "subjectAccount",
  action: "action",
  status: "status",
  subjectSite: "subjectSite",
  resource: "resource",
};

export const DEFAULT_TIMEZONE_VALUE = "Europe/London";

export const CAREGIVER_RELATIONSHIP = {
  caregiver: "Caregiver",
  participant: "Participant",
};

export const AUDIT_TRAIL_MAX_LENGTH_FILTER_INPUT = 50;

export const AUDIT_TRAIL_EVENTS_PAGE_SIZE = 200;

export const HTTP_REQUEST_CUSTOM_ERROR = {
  accessDenied: "Access denied.",
};

export const AuditTrailObjectIdRegex = new RegExp("^([a-zA-Z_]+:) *(\\S+)$");

export const AuditTrailMaxBytesLargeDiff = 500;

export const DEFAULT_REASON_FOR_CHANGE = {
  paperRecapture: "Reconciling against source.",
  deleteMeal: "Adjustment after interview with subject.",
  "24HourRecall": "Adjustment after interview with subject.",
};
